module.exports = __webpack_public_path__ + "img/w16.eaa27eb4.svg";